import React from "react";

import "./styles.scss"
import SourceListMain from "../../esg-chat/source-list";

const CompanySourceList = () => {
    return (
        <SourceListMain model="Company" />
    )
}

export default CompanySourceList